export default {
  sectionTitle: {
    id: 'buyback_categories_section_title',
    defaultMessage: 'Wanna sell something else?',
  },
  alternativeNext: {
    id: 'buyback_categories_alternative_next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'buyback_categories_alternative_previous',
    defaultMessage: 'Previous',
  },
}
